<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="true">
  <app-grow-project-detail
    [growAccount]="growAccount"
    [project]="project"
    [projectTotalInvestments]="projectTotalInvestments"
    [language]="language"
    (activeTabChange)="onTabChanged($event)"
  >
    <app-inyova-grow-deposit-widget
      *ngIf="showDepositWidget && growAccount.step_status === accountStatus.OPENED"
      [growAccount]="growAccount"
    ></app-inyova-grow-deposit-widget>
  </app-grow-project-detail>
  <div
    *ngIf="
      project.investments.length > 0 &&
      project.investments[0].status === projectStatus.INTERESTED &&
      project.stage === projectStage.INVESTABLE &&
      growAccount.step_status === 5
    "
  >
    <app-ds-button (clicked)="onToggleProject()" variant="outline">
      {{ 'GROW.project.buttons.deselectProject' | translate }}
    </app-ds-button>
  </div>
</ion-content>
<ion-footer>
  <div class="inyova-grow-project-action">
    @if (
      project.stage === projectStage.CLOSED ||
      project.stage === projectStage.ENDED ||
      project.stage === projectStage.CANCELLED ||
      (project.stage === projectStage.INVESTABLE && growAccount.step_status === 5 && !project.account_specific.maximum_regulatory_additional_amount)
    ) {
      <app-ds-button (clicked)="onDismiss()" *ngIf="!isPerformancePage">
        {{ 'GROW.project.buttons.backToProjects' | translate }}
      </app-ds-button>
    } @else {
      @if (project.stage === projectStage.ANNOUNCED || (project.stage === projectStage.INVESTABLE && growAccount.step_status !== 5)) {
        <app-ds-button
          (clicked)="onToggleProject()"
          variant="{{ project.investments.length > 0 && project.investments[0].status === projectStatus.INTERESTED ? 'outline' : 'primary' }}"
        >
          {{
            (project.investments.length > 0 && project.investments[0].status === projectStatus.INTERESTED
              ? 'GROW.project.buttons.deselectProject'
              : 'GROW.project.buttons.selectProject'
            ) | translate
          }}
        </app-ds-button>
      }
      @if (project.stage === projectStage.INVESTABLE && growAccount.step_status === 5) {
        <app-ds-button (clicked)="onFinishInvestment()">
          {{
            (project.investments.length > 0 && (project.investments[0].status === projectStatus.COMMITTED || project.investments[0].status === projectStatus.INVESTED)
              ? 'GROW.project.buttons.investMore'
              : 'GROW.project.buttons.finishInvestment'
            ) | translate
          }}
        </app-ds-button>
      }
    }
  </div>
</ion-footer>
